import { action } from 'easy-peasy';
import { IActionSetUpdatedBloodPressureReading } from '../types';

const setUpdatedBloodPressureReading: IActionSetUpdatedBloodPressureReading = action(
  (state, payload) => {
    if (state.latestReadings.latestReadings.bloodPressure.id === payload.id) {
      state.latestReadings.latestReadings.bloodPressure = payload;
    }
  },
);

export default setUpdatedBloodPressureReading;
